import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
  state: {
    notificacao: [
      // {
      //   url: 'Pedidos/Novos',
      //   quantidade: 0
      // }
    ]
  },
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/notificacaoTabs/index.js